<script lang="ts">
  import { userStore } from '../stores/auth.store';
  import Dashboard from '../pages/common/Dashboard.svelte';
  import CharityDashboard from '../pages/charity/CharityDashboardPage.svelte';
  import EmployeeDashboard from '../pages/employee/EmployeeDashboard.svelte';
  import EmployerDashboard from '../pages/employer/Dashboard.svelte';

  // Get user role for role-based dashboard rendering
  $: userRole = $userStore?.user_role?.name || 'User';
  console.log("userRole", $userStore?.user_role?.name);
  console.log("userRole", userRole);
</script>

{#if $userStore?.user_role?.name === 'Charity'}
    <CharityDashboard />
{:else if $userStore?.user_role?.name === 'User'}
  <EmployeeDashboard />
{:else if $userStore?.user_role?.name === 'Employer'}
  <EmployerDashboard />
{:else}
  <Dashboard />
{/if}

<style>
  /* These wrapper classes are no longer needed as they were causing layout issues */
</style> 